<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="0"></titled>
    <span class="apphome">
      <div class="left">
        <div class="box">
          <div class="t">健康状态分析</div>
          <div class="content">
            <div class="fenxi">
              <el-progress class="progress" type="circle" :percentage="healthyList.healthIndex" :stroke-width="20"
                :width="150" color="#4ca5ff" stroke-linecap="butt" :show-text="false"></el-progress>
              <div class="num">{{healthyList.healthIndex}}%</div>
              <div class="name">健康指数</div>
            </div>
            <div class="fenxi">
              <el-progress class="progress" type="circle" :percentage="healthyList.lifetime" :stroke-width="20"
                :width="150" color="#55bc3b" stroke-linecap="butt" :show-text="false"></el-progress>
              <div class="num">{{healthyList.lifetime}}%</div>
              <div class="name">电气剩余寿命</div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="t">下次保养前的时间</div>
          <div class="content">
            <div class="fenxi">
              <el-progress class="progress" type="circle" :percentage="dayPercentage" :stroke-width="20" :width="150"
                color="#ffc737" stroke-linecap="butt" :show-text="false"></el-progress>
              <div class="num">{{healthyList.remainingDays}}天</div>
              <div class="name">健康指数</div>
            </div>
            <div class="fenxi" style="display: flex;flex-direction: column;justify-content: center; ">
              <div class="p">下次维护时间：{{healthyList.nextTime | date_format}}</div>
              <!-- <div class="p">上次维护时间：2020/7/2</div> -->
            </div>
          </div>
        </div>
        <div class="box">
          <div class="t">检测数据</div>
          <div class="content">
            <div class="fenxi">
              <el-progress class="progress" type="circle" :percentage="testingData.averageLoad" :stroke-width="20"
                :width="150" color="#4ca5ff" stroke-linecap="butt" :show-text="false"></el-progress>
              <div class="num">{{testingData.averageLoad}}%</div>
              <div class="name">平均负载电流</div>
            </div>
            <div class="fenxi">
              <div class="ul">
                <div class="li">
                  <div class="n">操作次数</div>
                  <div class="txt" style="color: #FF1E1E;">{{testingData.operation}}</div>
                </div>
                <div class="li">
                  <div class="n">实际状态</div>
                  <div class="txt">{{testingData.status}}</div>
                </div>
                <div class="li">
                  <div class="n">实际位置</div>
                  <div class="txt">{{testingData.location}}</div>
                </div>
                <div class="li">
                  <div class="n">操作模式</div>
                  <div class="txt">{{testingData.pattern}}</div>
                </div>
                <div class="li">
                  <div class="n">任意警报</div>
                  <div class="txt" style="color: #55BC3B;">{{testingData.randomAlarm}}</div>
                </div>
                <div class="li">
                  <div class="n">脱扣警报</div>
                  <div class="txt" style="color: #55BC3B;">{{testingData.tripAlarm}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="t">环境数据</div>
          <div class="content" style=" justify-content: center; ">
            <div class="left_box">
              <div class="p">
                <div class="name">温度</div>
                <div class="txt">0-25℃</div>
              </div>
              <div class="p" style="margin-bottom: 46px; ">
                <div class="progressed"><span style="width: 40%;"></span></div>
              </div>
              <div class="p">
                <div class="name">湿度</div>
                <div class="txt">低于70%</div>
              </div>
              <div class="p">
                <div class="progressed" style="background: #D8F6FF;"><span
                    style="background: #63D7FC;width: 70%;"></span></div>
              </div>
            </div>
            <div class="right_box">
              <div class="p">
                <div class="name">震动</div>
                <div class="txt">低</div>
              </div>
              <div class="p">
                <div class="name">腐蚀度</div>
                <div class="txt">低</div>
              </div>
              <div class="p">
                <div class="name">粉尘级别</div>
                <div class="txt">低</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="t">最新事件</div>
        <el-table stripe :data="tableData" style="width: 100%" height="calc(100vh - 262px)" border>
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <!-- <el-table-column prop="eventtime" label="日期" width="126">

          </el-table-column> -->
          <el-table-column label="日期" align="center" width="120">
            <template #default="{row}">
              <span>{{row.eventtime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkobject" label="名称" width="120" align="center">
          </el-table-column>
          <el-table-column prop="description" label="描述" min-width="200" align="center">
          </el-table-column>
        </el-table>
        <!-- <el-pagination style="text-align: center;" layout="prev, pager, next" :total="20">
        </el-pagination> -->
      </div>
    </span>
  </div>
</template>
<script>

  import titled from '@/components/module/titled/titled.vue';
  import {findDevicesHealth,findAlarm} from "../../api/maintain";
  export default {
    components: {
      titled
    },
    data () {
      return {
        tableData: [],
        nowDevice: {},//当前设备
        dayPercentage: 91,
        //健康指数
        healthyList: {
          "healthIndex": 50,
          "lifetime": 0.9999,
          "monitorData": null,
          "nextTime": 1703303366535,
          "remainingDays": 365,
        },
        //检测数据
        testingData: {},
        //环境数据
        environmentData: {},
        //最新事件表格数据
        newTable: []
      }
    },
    computed: {
      setDeviceItem () {
        return this.$store.cacheStore.state.setDevice
      },
    },
    watch: {
      setDeviceItem: function(val) {
        // console.log("变化综览",val);
        // this.value = val.deviceName
        this.nowDevice=val
        this.healthy_fn()
      },

    },
    mounted () {
    },
    methods: {
      healthy_fn () {
        findDevicesHealth({'deviiceNo': this.nowDevice.deviceNo}).then(res => {
          //  console.log("健康指数",res);
          if(res.code==200) {
            this.healthyList=res.data
            // this.healthyList.remainingDays
            this.testingData=res.data.monitorData
            // this.environmentData
            // this.newTable
            this.dayPercentage=parseFloat((this.healthyList.remainingDays/365*100).toFixed(2))
          }
        })

        findAlarm({'dateType': 'YEAR','deviiceNo': this.nowDevice.deviceNo}).then(res => {
          // console.log("最新事件",res);
          this.tableData=[]
          if(res.code==200) {
            res.data.forEach((item,index) => {
              if(index<10) {
                this.tableData.push(item)
              }
            })
            // this.tableData = res.data
          }
        })
      }

    },
    //过滤器
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .right_box {
    padding-top: 20px;
  }

  .right_box .p {
    width: 100px;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
  }

  .right_box .p .name {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  .right_box .p .txt {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #FF1E1E;
  }

  .left_box {
    width: 51%;
    margin-right: 40px;
  }

  .left_box .p .progressed {
    width: 100%;
    height: 20px;
    background: #FFEDED;
    border-radius: 8px;
  }

  .left_box .p .progressed>span {
    display: block;
    width: 91.01px;
    height: 20px;
    background: #FF7F7F;
    border-radius: 8px;
  }

  .left_box .p {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  .left_box .p .name {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  .left_box .p .txt {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #FF1E1E;
  }



  .fenxi .ul .li {
    display: flex;
    margin-bottom: 12px;
  }

  .fenxi .ul .li .n {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-right: 20px;
  }

  .fenxi .ul .li .txt {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #4CA5FF;
    ;
  }

  .apphome .el-table td {
    // border: none;
  }


  .apphome {
    padding: 15px;
    overflow-x: scroll;
    display: flex;
    margin-top: 1rem;
  }

  .apphome .left {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .apphome .left .box {
    width: 49%;
    height: 270px;
    background: #FFF;
    border-radius: 8px;

  }

  .apphome .left .box:nth-child(1) {
    margin-bottom: 20px;
  }

  .apphome .left .box:nth-child(2) {
    margin-bottom: 20px;
  }

  .apphome .t {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    color: #000;
    padding: 20px;
  }

  .apphome .left .box .content {
    display: flex;
    justify-content: space-around;
  }

  .apphome .left .box .content .fenxi {
    position: relative;
  }

  .apphome .left .box .content .fenxi .progress {
    transform: rotate(90deg);
  }

  .apphome .left .box .content .fenxi .num {
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'DIN';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 20px;
    color: #000;
    white-space: nowrap;
  }

  .apphome .left .box .content .fenxi .p {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #000;
    margin-bottom: 12px;
  }

  .apphome .left .box .content .fenxi .name {
    text-align: center;
    margin-top: 5px;
  }

  .apphome .right {
    width: 350px;
    background-color: #FFF;
    margin-left: 20px;
    height: calc(100vh - 162px);
    border-radius: 8px;
  }
</style>